
import {security} from 'common/util';
export default ()=>(
  {

    api:{
      /* the root fetch the data */
      root: '/api/',

      /* the authorize config when fetch data, now only support bearer */
      security:security()
    }
  }
);



// WEBPACK FOOTER //
// ./src/common/components/extend/process-chart-editor/config/index.js